<template>
  <BtnToggle 
    :title="$t('engine.manageText.modalWidget.tooltip.lblIndent', languageEngine)"
    @click="onChange(value + 1)"
  >
    <i class="far fa-indent fs-16"></i>
  </BtnToggle>
</template>

<script>
import { mapGetters } from "vuex";
import BtnToggle from "./_BtnToggle";

export default {
  components: {
    BtnToggle,
  },
  computed: {
    ...mapGetters({
      languageEngine: "designIframe/userPreference/languageEngine",
      texteditor: "designIframe/texteditor/texteditor",
    }),
    selectionFormatMerge() {
      return this.texteditor.selectionFormatMerge;
    },
    value() {
      return this.normalizeValue(this.selectionFormatMerge.indent);
    },
  },
  methods: {
    normalizeValue(value) {
      if (value === undefined) return 0;
      return Math.max(Number(value), 0);
    },
    onChange(value) {
      value = this.normalizeValue(value);
      const selection = this.texteditor.editor.getSelection();
      let formatValue = value ? value : false;

      this.texteditor.editor.formatLine(selection, { indent: formatValue });
    }
  },
}
</script>
